import React from 'react';
import { footerData, navigationData } from '../../data/mock';

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#070d18] py-10 sm:py-16">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col items-center gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Logo */}
          <a
            href="#"
            className="text-xl sm:text-2xl font-light tracking-[0.15em] text-[#c9a96e] uppercase"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {footerData.logo}
          </a>

          {/* Navigation */}
          <ul className="flex flex-wrap items-center justify-center gap-4 sm:gap-8">
            {navigationData.links.map((link) => (
              <li key={link.label}>
                <button
                  onClick={() => scrollToSection(link.href)}
                  className="text-[10px] sm:text-[11px] text-white/50 hover:text-[#c9a96e] transition-colors duration-300 uppercase tracking-[0.1em]"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 sm:pt-8">
          <p
            className="text-[9px] sm:text-[10px] text-white/30 text-center uppercase tracking-wider"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
